import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  loading: {
    send: false,
    search: false,
    menuList: false,
    agencyMarginList: false,
    salesAccountList: false,
  },
  keyword: '',
  pageNo: 1,
  pageSize: 20,
  ioStatuses: ['active', 'inactive'],
  sortOptions: {
    sortBy: 'id',
    descending: true,
  },
  searchResult: {},
  menuList: [],
  agencyMarginList: [],
  salesAccountList: [],
  inventoryLists: [],
}

const insertionOrders = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default insertionOrders
